// FIXME: these routes do not follow the rest of the app guidelines
// TODO: enforce /path/:action/:id
export const paths = ['/projects/summary/:projectId'];
